import React from 'react';

import ProductInfo from 'components/ProductInfo';
import Status from 'shared/Status';
import { IOrderBump } from 'types/interfaces/orderBump';

import DotsHorizontal from '@eduzz/houston-icons/DotsHorizontal';

import { TranslateStatus } from '..';
import { ItemStatusContainer, RowGrid, ButtonIcon } from './styles';

interface IProps extends IOrderBump {
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

const BumpItemMobile: React.FC<IProps> = ({ id, owner, status, onClick }) => {
  return (
    <RowGrid key={id}>
      <ItemStatusContainer>
        <Status text={TranslateStatus[status]} type={status} />
        <ButtonIcon onClick={onClick}>
          <DotsHorizontal size={28} />
        </ButtonIcon>
      </ItemStatusContainer>
      <ProductInfo product={owner} />
    </RowGrid>
  );
};

export default React.memo(BumpItemMobile);
